import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';

const routes = [
  /*
  {
    path: '/',
    name: 'En Construcción',
    component: () => import('../views/Construction.vue'),
  },
  */
  {
    path: '/',
    name: 'Inicio',
    meta: { hideFromFooterMenu: true },
    component: HomeView,
  },
  {
    path: '/tecnologias',
    name: 'Tecnologías',
    meta: { title: 'Tecnologías', hideFromFooterMenu: true },
    component: () => import('../views/PageView.vue'),
    children: [
      {
        path: '/bases-de-datos',
        name: 'Bases de Datos',
        meta: { title: 'Bases de Datos para los sistemas', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/desarrollo',
        name: 'Desarrollo',
        meta: { title: 'Metodologías, Tecnologías y Pruebas de Desarrollo', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/plataformas',
        name: 'Plataformas',
        meta: { title: 'Plataformas ERP, CRM, CMS y Cloud', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/servidores',
        name: 'Servidores',
        meta: { title: 'Físicos, Virtuales y Cloud', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
    ],
  },
  {
    path: '/productos',
    name: 'Productos',
    meta: { title: 'Productos', hideFromFooterMenu: true },
    component: () => import('../views/PageView.vue'),
    children: [
      {
        path: '/big-data',
        name: 'Big Data',
        meta: { title: 'datos masivos, inteligencia de datos', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/cms-sistema-de-administracion-de-contenido',
        name: 'CMS',
        meta: { title: 'Sistema de Administración de Contenido / sitios web dinámicos', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/crm-sistema-de-administracion-de-relaciones-con-clientes',
        name: 'CRM',
        meta: { title: 'Sistema de Administración de Relaciones con Clientes', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/e-commerce-sistema-de-comercio-electronico',
        name: 'e-Commerce',
        meta: { title: 'Sistema de Comercio Electrónico', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/erp-sistema-de-administracion-de-recursos-empresariales',
        name: 'ERP',
        meta: { title: 'Sistema de Administración de Recursos Empresariales', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/lcms-sistema-de-gestion-de-contenido-para-el-aprendizaje',
        name: 'LCMS',
        meta: { title: 'Sistema de Gestión de Contenido para el Aprendizaje', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
    ],
  },
  {
    path: '/servicios',
    name: 'Servicios',
    meta: { title: 'Servicios', hideFromFooterMenu: true },
    component: () => import('../views/PageView.vue'),
    children: [
      {
        path: '/arquitectura-sistemas',
        name: 'Arquitectura de Sistemas',
        meta: { title: 'Arquitectura de Sistemas', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/centro-de-datos-hosting-cloud',
        name: 'Centro de Datos / Hosting / Cloud',
        meta: { title: 'Centro de Datos / Hosting / Cloud', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/community-manager-gestion-de-la-comunidad-online',
        name: 'Community Manager',
        meta: { title: 'Gestión de la Comunidad Online', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/correo-electronico',
        name: 'Correo Electrónico',
        meta: { title: 'Correo Electrónico', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/desarrollo-web',
        name: 'Desarrollo Web',
        meta: { title: 'Desarrollo Web', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/desarrollo-de-sistemas',
        name: 'Desarrollo de Sistemas',
        meta: { title: 'Desarrollo de Sistemas', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/e-marketing-mercadotecnia-online',
        name: 'e-Marketing',
        meta: { title: 'Mercadotecnia Online', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/email-marketing-mercadotecnia-en-correos-electronicos',
        name: 'email Marketing',
        meta: { title: 'Mercadotecnia en Correos Electrónicos', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/investigacion-desarrollo-e-innovacion-de-nuevas-tecnologias',
        name: 'I+D+I',
        meta: { title: 'Investigación, Desarrollo e Innovación de Nuevas Tecnologías', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/iaas-infraestructura-como-servicio',
        name: 'IaaS',
        meta: { title: 'Infraestructura como Servicio', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/paas-plataforma-como-servicio',
        name: 'PaaS',
        meta: { title: 'Plataforma como Servicio', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/saas-software-como-servicio',
        name: 'SaaS',
        meta: { title: 'Software como Servicio', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/project-management-gestion-de-proyectos',
        name: 'Project Management',
        meta: { title: 'Gestión de Proyectos', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/sem-mercadotecnia-para-motores-de-busqueda',
        name: 'SEM',
        meta: { title: 'Mercadotecnia para Motores de Búsqueda', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/seo-optimizacion-para-motores-de-busqueda',
        name: 'SEO',
        meta: { title: 'Optimización para Motores de Búsqueda', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/smo-optimizacion-para-redes-sociales',
        name: 'SMO',
        meta: { title: 'Optimización para Redes Sociales', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/smm-mercadotecnia-en-redes-sociales',
        name: 'SMM',
        meta: { title: 'Mercadotecnia en Redes Sociales', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
      {
        path: '/virtualizacion',
        name: 'Virtualización',
        meta: { title: 'Virtualización', hideFromFooterMenu: true },
        component: () => import('../views/PageView.vue'),
      },
    ],
  },
  {
    path: '/contact',
    name: 'Contacto',
    component: () => import('../views/ContactView.vue'),
  },
  {
    path: '/privacidad',
    name: 'Políticas de Privacidad',
    meta: { hideFromHeaderMenu: true },
    component: () => import('../views/PageView.vue'),
  },
  {
    path: '/terminos',
    name: 'Términos de Servicio',
    meta: { hideFromHeaderMenu: true },
    component: () => import('../views/PageView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    meta: { hideFromHeaderMenu: true, hideFromFooterMenu: true },
    component: HomeView,
  },
  /*
  {
    //path: '/contacto',
    path: '/',
    name: 'Contacto',
    hash: '#contacto',
    component: Home,
  },
  {
    path: '/:pathMatch(.*)*',
    component: Home,
  },
  */
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to === undefined) {
      console.log('to', to);
      console.log('from', from);
      console.log('savedPosition', savedPosition);
    }
    if (to.hash) {
      return { el: to.hash };
    }
  },
});

export default router;
